/* @flow */
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import Badge from 'material-ui/Badge';
import { Tab, Tabs } from 'material-ui/Tabs';

import TutorHistory from './TutorHistory';
import TutorBooked from './TutorBooked';
import TutorPending from './TutorPending';

import type { TutorJobs_tutor } from './__generated__/TutorJobs_tutor.graphql';

type Props = {
  tutor: TutorJobs_tutor,
};

type State = {
  tab: string,
};

class TutorJobs extends Component<Props, State> {
  state = {
    tab: 'booked',
  };

  handleChange = (tab: string) => {
    this.setState({ tab });
  };

  render() {
    const { tutor } = this.props;
    const { tab } = this.state;

    const { startedJobsCount, openJobOffersCount } = tutor;

    return (
      <Tabs value={tab} onChange={this.handleChange}>
        <Tab
          label={
            <Badge
              badgeContent={startedJobsCount}
              secondary
              badgeStyle={{ top: 12, right: -10 }}
            >
              Booked
            </Badge>
          }
          value="booked"
        >
          {tab === 'booked' && <TutorBooked tutor={tutor} />}
        </Tab>
        <Tab
          label={
            <Badge
              badgeContent={openJobOffersCount}
              secondary
              badgeStyle={{ top: 12, right: -10 }}
            >
              Pending
            </Badge>
          }
          value="pending"
        >
          {tab === 'pending' && <TutorPending tutor={tutor} />}
        </Tab>
        <Tab label="History" value="history">
          {tab === 'history' && <TutorHistory tutor={tutor} />}
        </Tab>
      </Tabs>
    );
  }
}

export default createFragmentContainer(TutorJobs, {
  tutor: graphql`
    fragment TutorJobs_tutor on Tutor {
      startedJobsCount
      openJobOffersCount
      ...TutorHistory_tutor
      ...TutorPending_tutor
      ...TutorBooked_tutor
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/TutorJobs.js